import {
  FormsActionType,
  ADD_FORMS,
  DataForms,
  DELETE_FORMS,
  UPDATE_FORMS
} from "./types";

const initialState: DataForms[] = [];

export function FormsReducers(
  state = initialState,
  action: FormsActionType
): DataForms[] {
  switch (action.type) {
    case ADD_FORMS:
      return [...state, ...[action.data]];
    case DELETE_FORMS:
      const dataSource = [...state];
      let newdata = dataSource.filter(
        (item: any) => item.id !== action.data.id
      );
      return [...newdata];
    case UPDATE_FORMS:
      const index = state.findIndex((post: any) => post.id === action.data.id);
      return state.map((content, i) =>
        i === index ? { ...content, ...action.data } : content
      );

    default:
      return state;
  }
}
